import { useRouter } from 'next/router'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import NotificationWrapper from '~/shared/layouts/components/HeaderTop/components/NotificationWrapper'
import { NotificationData } from '~/shared/types/notification.types'
import { AppLanguage } from '~/types/locale'

export default function SystemNotification({
  data,
  parentClassNames,
}: {
  data: NotificationData
  parentClassNames: string
}): React.ReactElement {
  const router = useRouter()
  const messageData = data.message[router.locale as AppLanguage]
  if (!messageData) {
    return <></>
  }
  return (
    <Link className="relative flex w-full" to={messageData.link}>
      <NotificationWrapper createdAt={data.createdAt} parentClassNames={parentClassNames}>
        <div className="flex items-center py-2">
          <ResponsiveImage
            alt={messageData.title}
            className="min-w-max px-5"
            fit="contain"
            height={64}
            srcKey={messageData.srcKey}
            width={56}
          />
          <div className="relative pr-2">
            <h3 className="font-semibold text-md uppercase">{messageData.title}</h3>
            <p className="text-sm">{messageData.body}</p>
            {messageData.buttonText && (
              <button className="absolute text-sm text-white bg-purple rounded px-2 py-0.5 right-6 -mt-1 hover:scale-110 duration-300">
                {messageData.buttonText}
              </button>
            )}
          </div>
        </div>
        {!data.isRead && (
          <div className="absolute flex justify-center items-center right-3 bottom-3">
            <span className="animate-ping absolute inline-flex rounded-full bg-purple-bright opacity-75 w-3.5 h-3.5" />
            <span className="absolute flex justify-center items-center rounded-full bg-purple w-2.5 h-2.5 text-xxs font-semibold" />
          </div>
        )}
      </NotificationWrapper>
    </Link>
  )
}
